import { SolrParamsKey } from '#shared/solr'

export function useLiteratureSearch(searchTerm: Ref<string>, bookId?: MaybeRef<string | null | undefined>) {
  const debouncedSearchTerm = useDebounce(searchTerm, 500)

  function getSearchQueryOptions(bookIdValue: string, rawSearchTerm: string) {
    const cleanTerm = rawSearchTerm?.trim() || ''
    const pageNumberMatch = cleanTerm.match(/^(?:side\s*|s\.?\s*)(\d+)$/i)

    return {
      searchTerm: pageNumberMatch ? `pageNumberString:"${pageNumberMatch[1]}"` : cleanTerm,
      id: `${bookIdValue}*`,
      contentType: ['book_page'],
    }
  }

  const queryParams = computed(() => {
    const bookIdValue = toValue(bookId)
    const searchTermValue = debouncedSearchTerm.value

    if (!searchTermValue) {
      return null
    }

    if (bookIdValue) {
      return {
        [SolrParamsKey.SearchLiterature]: getSearchQueryOptions(bookIdValue, searchTermValue),
      }
    }

    return {
      [SolrParamsKey.SearchLiterature]: {
        searchTerm: searchTermValue,
      },
    }
  })

  const { data: solrData, isLoading } = useSolrQueryV2(queryParams, 'page', 'search')
  const searchResult = computed(() => solrData.value)

  return {
    searchResult,
    isLoading,
  }
}
